import { render, staticRenderFns } from "./HomeStepUp.vue?vue&type=template&id=6856a2d2&scoped=true&"
import script from "./HomeStepUp.vue?vue&type=script&lang=js&"
export * from "./HomeStepUp.vue?vue&type=script&lang=js&"
import style0 from "./HomeStepUp.vue?vue&type=style&index=0&id=6856a2d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6856a2d2",
  null
  
)

export default component.exports